<template lang="pug">
  .align-center.rc-uploader
    v-card(flat mx-0 px-0)
      v-card-text.pa-0(align-center justify-center)
        v-avatar.pa-5.avatar(size="80" :tile="tile")
          v-img(alt="avatar" :src="imageUrl" v-if="imageUrl" :style="grayscale ? 'filter: grayscale(100%);' : ''")
          //- v-img(alt="avatar" :src="url" v-else-if="url")
          v-icon(size="80" v-else) {{ fallbackIcon }}
          v-btn.fileButton(
            absolute
            color="primary"
            dark
            fab
            @click='pickFile'
            small
            v-if="!readonly"
          )
            v-icon add_to_photos
          v-btn.removeButton(
            absolute
            color="error"
            dark
            fab
            @click='removeFile'
            small
            v-if="!readonly && (imageUrl)"
          )
            v-icon close
          input(
            data-test="upload-logo-input"
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
            @input="onFilePicked"
            @click="$refs.image.value = null"
            v-if="!readonly"
          )
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    fallbackIcon: {
      type: String,
      default: 'account_circle',
    },
    tile: {
      type: Boolean,
      default: false,
    },
    grayscale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageName: '',
      imageFile: '',
      imageUrl: this.url,
    };
  },
  watch: {
    url(newValue) {
      this.imageUrl = newValue;
    }
  },
  methods: {
    pickFile() {
      this.$refs.image.click();
    },
    removeFile() {
      this.imageUrl = '';
      this.$emit('remove');
      this.$refs.image.src = '';
    },
    onFilePicked(e) {
      const { files } = e.target;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (files[0].name.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          const file = fr.result;
          [this.imageFile] = files; // this is an image file that can be sent to server...*
          const sizeFiel = (Math.abs(parseInt(this.imageFile.size, 10)) / 1024);
          if (sizeFiel > parseInt(process.env.VUE_APP_MAX_SIZE_AVATAR, 10)) {
            e.value = '';
            this.imageName = '';
            this.imageFile = '';
            return this.$emit('error', { code: 'SIZE_TOO_LARGE' });
          }
          this.imageUrl = file;
          return this.$emit('upload', this.imageFile);
        });
      } else {
        this.imageName = '';
        this.imageFile = '';
      }
    },
  },
};
</script>

<style lang="scss">
  .rc-uploader {
    .avatar {
      position: relative;
    }
    .fileButton {
      position: absolute;
      top: 0;
      left: 75px;
    }
    .removeButton {
      position: absolute;
      bottom: 0;
      left: 75px;
    }
  }
</style>
